import React from "react"
import { eventsItem } from "../agenda.module.scss"
import EvenementContent from "gatsby-theme-cactus/src/gatsby-theme-blank/components/Home/Agenda/EvenementContent/evenement-content"
import PropTypes from "prop-types"

const RenderEvenements = ({ eventsData, choosenTag }) => {
  let events
  if (choosenTag === "Tous" || choosenTag === undefined) {
    events = eventsData
  } else {
    events = eventsData.filter(
      ({ node }) =>
        node.relationships?.field_taxonomie_thematique[0]?.name === choosenTag
    )
  }
  return (
    <>
      {events.map(({ node }) => (
        <article key={node.drupal_id} className={eventsItem}>
          <EvenementContent evenement={node} />
        </article>
      ))}
    </>
  )
}

RenderEvenements.propTypes = {
  eventsData: PropTypes.array.isRequired,
  choosenTag: PropTypes.string,
}

export default RenderEvenements
